import { Course } from "@interfaces/course/course"
import { CourseProgress } from "@interfaces/dashboard/course-dashboard"
import { Category } from "@interfaces/course/category"
import { PaginationData } from "@interfaces/misc"
import CourseListRepositories from "../repositories/course-list.repositories"
import { Result } from "./result"

export interface CoursePagination {
  data: Course[]
  current_page: number
  next_page?: number
  total_data: number
  total_page: number
}

export default class CourseListServices extends CourseListRepositories {
   async getCourseList(query: any) {
    try {
      const res = await this.getRawCourses(query)

      const response = await this._getResponse<CoursePagination>(res)

      if (response.error) {
        return Result.fail<CoursePagination>()
      }

      const result = response.result

      if (result) {
        return Result.ok<CoursePagination>(result)
      } else {
        return Result.ok<CoursePagination>({
          data: [],
          total_page: 1,
          total_data: 0,
          current_page: 1,
        })
      }
    } catch (e) {
      return Result.fail<CoursePagination>()
    }
  }

  async getCategoryList() {
    try {
      const res = await this.getRawCategories()

      const response = await this._getResponse<Category[]>(res)

      if (response.error || !response.result) {
        return Result.fail<Category[]>()
      }

      return Result.ok<Category[]>(response.result)
    } catch (e) {
      return Result.fail<Category[]>()
    }
  }

  async getCourseProgressList(query: any) {
    try {
      const res = await this.getRawCourseProgress(query)

      const response = await this._getResponse<CourseProgress[]>(res)

      if (response.error) {
        return Result.fail<CourseProgress[]>()
      }

      return Result.ok<CourseProgress[]>(response.result)
    } catch (e) {
      return Result.fail<CourseProgress[]>()
    }
  }
}
